import ContentWrapper from './ContentDarkBackground'

export default ContentWrapper
